<template>
  <div id="app" ref="app" :class="isWebClass ? 'app-web' : 'app-mobile'">
    <router-view />
  </div>
</template>

<script>
// import io from 'socket.io-client';
export default {
  name: 'App',
  data() {
    return {
      downY: 0,
      upY: 0,
      isWebClass: null, //根据长宽比确定是用web样式还是移动端样式
    };
  },
  created() {
    //  由于显示问题，在切换横竖屏时页面刷新页面
    // window.addEventListener("orientationchange", function() {
    //   location.reload();
    //   //document.getElementsByTagName('body')[0].style.zoom=2;
    // }, false);

    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem('userMsg') &&
      this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('userMsg'))));

    //在页面刷新时将vuex里的信息保存到localStorage里
    //  window.addEventListener("beforeunload",()=>{
    //      localStorage.setItem("userMsg",JSON.stringify(this.$store.state))
    //  })

    //socket.io获取面试者的登录状态
    // var socket = io(this.socketIoURL,{
    //   path:'/manage'
    // });
    // socket.on('connected',function(){
    //   console.log('connected success!')
    // })
    // socket.on('getInterviewerStatus',(res)=>{
    //   //if(this.$store.state.isVideo){
    //   this.$store.commit('storeInterviewerStatus',res);
    //   //}
    //   console.log(res);
    // })

    //北京时间
    var now = Date.PekingTime();
    this.$store.commit('storeBJTime', now);
    // setInterval(() => {
    //   now += 60000;
    //   this.$store.commit('storeBJTime', now);
    // }, 60000);
    // 每10秒更新一次
    setInterval(() => {
      now += 10000;
      this.$store.commit('storeBJTime', now);
    }, 10000);

    //是否是移动端
    this.isWebClass = window.innerHeight < window.innerWidth;
    this.$store.commit('storeIsMobile');
  },
  watch: {
    isWebClass() {
      this.$store.commit('storeIsMobile', !this.isWebClass);
    },
  },
  mounted() {
    //全屏、退出全屏事件监听
    const app = this.$refs.app;
    const requestFullScreen = app.webkitRequestFullScreen || app.msRequestFullScreen || app.mozRequestFullScreen;
    const exitFullscreen =
      document.webkitExitFullscreen ||
      document.webkitCancelFullScreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen;

    // document.addEventListener("mousedown", (e) => {
    //   this.downY = e.screenY;
    // });
    // document.addEventListener("mouseup", (e) => {
    //   this.upY = e.screenY;
    //   if(this.downY-this.upY>100){
    //     requestFullScreen.call(app)
    //   }else if(this.upY-this.downY>100){
    //     exitFullscreen.call(document)
    //   }
    // });

    //根据宽高比切换web端样式还是移动端样式
    window.addEventListener('resize', (e) => {
      if (e.target.innerHeight > e.target.innerWidth) {
        this.isWebClass = false;
      } else {
        this.isWebClass = true;
      }
    });
  },
};
</script>

<style lang="scss" type="text/scss">
@import '~@/assets/scss/element_modify.scss';

$min-width: 992px;
$min-height: 580px;

* {
  word-break: break-all;
  box-sizing: border-box;
  //-webkit-overflow-scrolling: touch;  //解决Safari没有滑动惯性
}

//去除ipad中点击按钮会出现一个半透明的灰色背景的问题
a,
img,
button,
input,
textarea,
div {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-appearance: none;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f6f7fb;
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    Segoe UI,
    Roboto,
    Ubuntu,
    Cantarell,
    Noto Sans,
    sans-serif,
    Apple Color Emoji,
    Segoe UI Emoji,
    Segoe UI Symbol,
    Noto Color Emoji;
}

#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  width: 100%;
  background: #f5f7fb;
  font-size: 15px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  #app {
    font-size: 12px;
  }
}

.app-web {
  height: 100%;
  width: 100%;
  min-width: $min-width;
  min-height: $min-height;
}

.app-mobile {
  height: 100%;
  width: 100%;
}

@font-face {
  font-family: 'iconfont';
  src: url('~@/assets/fonts/iconfont.eot');
  src:
    url('~@/assets/fonts/iconfont.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/iconfont.woff') format('woff'),
    url('~@/assets/fonts/iconfont.ttf') format('truetype'),
    url('~@/assets/fonts/iconfont.svg#iconfont') format('svg');
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(100, 100, 100, 0.3);
  border-radius: 3px;
  transition: background-color 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 100, 100, 0.5);
}

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 100, 100, 0.3) transparent;
}

html,
body {
  -webkit-overflow-scrolling: touch;
}
</style>
